module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-view",
    style: ({
      width: _vm.appWidth + 'px',
      left: _vm.appLeft + 'px'
    })
  }, [_c('sideview-button', {
    class: {
      active: _vm.detailsVisible, hidden: _vm.smallView && _vm.detailsVisible
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleView($event)
      }
    }
  }), _vm._v(" "), _c('map-view', {
    style: ({
      width: _vm.mapWidth + 'px'
    }),
    attrs: {
      "width": _vm.mapWidth,
      "mapVisible": !(_vm.smallView && _vm.detailsVisible)
    }
  }), _vm._v(" "), _c('vertical-splitter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.splitterVisible),
      expression: "splitterVisible"
    }],
    style: ({
      left: _vm.splitterLeft + 'px'
    }),
    nativeOn: {
      "mousedown": function($event) {
        _vm.beginMouseMove($event)
      },
      "touchstart": function($event) {
        _vm.beginTouchMove($event)
      }
    }
  }), _vm._v(" "), _c('details-view', {
    ref: "details",
    class: {
      'small-view': _vm.smallView
    },
    style: ({
      width: _vm.detailsWidth + 'px'
    }),
    attrs: {
      "redraw": (_vm.detailsWidth + "_" + _vm.smallView)
    },
    on: {
      "close-details": function($event) {
        _vm.detailsVisible = false
      }
    }
  }), _vm._v(" "), _c('time-control', {
    attrs: {
      "view-width": _vm.mapWidth,
      "shadow": !(_vm.smallView && _vm.detailsVisible)
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c908d1ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-view.vue
// module id = 349
// module chunks = 1